import { ReactNode } from "react"

type TooltipProps = {
  content: ReactNode
  children: ReactNode
}

const Tooltip = ({ content, children }: TooltipProps) => {
  if (!content) {
    return <>{children}</>
  }
  return (
    <div className="group relative inline-block">
      {children}
      <div className="pointer-events-none absolute left-1/2 top-full z-[9999] mt-2 hidden -translate-x-1/2 whitespace-nowrap rounded-md bg-black px-3 py-2 text-xs text-white group-hover:block">
        {content}
      </div>
    </div>
  )
}

export default Tooltip
